import ErrorPage from '@components/ErrorPage/ErrorPage'

const UnscoredCardError = () => {
    return <ErrorPage />
}

export default UnscoredCardError
